export const EXPENSES_MODULE_NAME = "expenses";
